import { get, trim } from 'lodash-es';
import { Currency } from '../types';

const currencyCode = {
  [Currency.KZT]: '₸',
  [Currency.RUB]: '₽',
  [Currency.EUR]: '€',
  [Currency.USD]: '$',
};

function getCurrencyCode(currency: Currency) {
  return get(currencyCode, currency);
}

function priceFormat(amount: number) {
  const numberFormat = new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 0,
  });

  return numberFormat.format(amount);
}

/**
 * TODO: Create a directive v-price to display price
 */
function prettyPrice(
  amount: number | string,
  currency: Currency = Currency.KZT,
) {
  const currencyCode = currency ? getCurrencyCode(currency) : '';

  return trim(`${priceFormat(Number(amount))} ${currencyCode}`);
}

/**
 * Formats a price interval in thousands
 * @param minAmount - Minimum amount
 * @param maxAmount - Maximum amount
 * @param currency - Currency code (default: KZT)
 * @returns Formatted interval string like "600 - 1200 ₸"
 */
function prettyPriceInterval(
  minAmount: number | string,
  maxAmount: number | string,
  currency: Currency = Currency.KZT,
) {
  const currencyCode = currency ? getCurrencyCode(currency) : '';

  return trim(
    `${priceFormat(Number(minAmount))} - ${priceFormat(
      Number(maxAmount),
    )} ${currencyCode}`,
  );
}

export const priceLib = {
  Currency,
  getCurrencyCode,
  priceFormat,
  prettyPrice,
  prettyPriceInterval,
};
